import { Link } from "react-router-dom";
import { Instagram, Linkedin } from "lucide-react";

const links = [
  { href: "/#work", label: "Work" },
  { href: "/#process", label: "The Process" },
  { href: "/#about", label: "About" },
  { to: "/services", label: "Services" },
  { href: "/#contact", label: "Contact" },
];

const socials = [
  {
    href: "https://www.linkedin.com/in/parastou-saba-6665b9150",
    label: "LinkedIn",
    icon: Linkedin,
    testid: "nav-social-linkedin",
  },
  {
    href: "https://www.instagram.com/the.directdesigner/",
    label: "Instagram",
    icon: Instagram,
    testid: "nav-social-instagram",
  },
];

export default function Nav() {
  return (
    <header
      className="sticky top-0 z-50 bg-[#FFFFFF]/95 backdrop-blur-sm border-b border-[#0A0A0A]"
      data-testid="site-nav"
    >
      <div className="max-w-[1440px] mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
        <a
          href="/"
          className="flex items-baseline gap-2.5 group"
          data-testid="nav-logo"
        >
          <span className="font-display text-xl tracking-tighter leading-none">
            PARAUX
          </span>
          <span className="label-mono text-[#595959] leading-none">
            Design studio
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) =>
            l.to ? (
              <Link
                key={l.label}
                to={l.to}
                className="label-mono hover:text-[#4C1D95] transition-colors"
                data-testid={`nav-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </Link>
            ) : (
              <a
                key={l.label}
                href={l.href}
                className="label-mono hover:text-[#4C1D95] transition-colors"
                data-testid={`nav-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            )
          )}
        </nav>

        <div className="flex items-center gap-4">
          <div className="hidden sm:flex items-center gap-3 pr-1">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noreferrer"
                aria-label={s.label}
                title={s.label}
                className="text-[#0A0A0A] hover:text-[#4C1D95] transition-colors"
                data-testid={s.testid}
              >
                {s.icon ? (
                  <s.icon className="w-[18px] h-[18px]" strokeWidth={1.75} />
                ) : (
                  <span className="label-mono">Up</span>
                )}
              </a>
            ))}
          </div>
          <a
            href="/#contact"
            className="bg-[#0A0A0A] text-[#FFFFFF] px-4 py-2 label-mono border border-[#0A0A0A] hover:bg-[#4C1D95] hover:border-[#4C1D95] transition-colors"
            data-testid="nav-cta-contact"
          >
            Get in touch ↗
          </a>
        </div>
      </div>
    </header>
  );
}
